import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'dmmp-tags-content',
  templateUrl: './tags-content.component.html'
})
export class TagsContentComponent implements OnInit {

  @Input() module: any
  @Input() identifier: string
  @Input() detailLayout: any
  @Output() page = new EventEmitter()
  url: string
  labelTags = 'Tags:'

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.url = '/' + this.router.url.split('/')[1];
  }

  redirect(tag) {
    this.router.navigate([this.url], {
      queryParams: {
        tag: this.formatText(tag),
      },
    })
    this.page.emit()
  }

  formatText(word) {
    return word.split(' ').join('-').toLowerCase().normalize('NFD')
      .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1")
      .normalize();
  }
}
